import { useRovoDevWebAnalyticsClient } from '@dev-agents/analytics';
import { useTenantData } from '@dev-agents/tenant-context';
import { useEffect } from 'react';

import { JiraProductAccessBoundary } from '../github-oauth-redirect/jira-product-access-boundary';

import { CreditRequestPage } from './index';

export const StandaloneCreditRequestPage = () => {
	const { tenantContexts } = useTenantData();
	const cloudId = tenantContexts[0]?.cloudId;
	const { fireScreenEvent } = useRovoDevWebAnalyticsClient();
	useEffect(() => {
		fireScreenEvent({ name: 'creditRequestPage' });
	}, [fireScreenEvent]);
	if (!cloudId) throw new Error('A Jira site is required to request Rovo credits');
	return (
		<JiraProductAccessBoundary key={cloudId} cloudId={cloudId}>
			<main>
				<CreditRequestPage cloudId={cloudId} />
			</main>
		</JiraProductAccessBoundary>
	);
};
